<div class="login-container" *ngIf="authStatusChceked">
  <div class="login-center-area">
    <!-- THE PRODUCT IDENTITY IS VERICURE. United Felts is the THEME, not the
         product, so its lockup does not belong on the sign-in screen — that is
         the one place a user is confirming what they are signing in TO.

         BRAND COBALT (#3C75BB), Joel's call: it is the brand accent and a
         wordmark is a logotype, which WCAG text-contrast rules do not govern.
         Measured, it sits at 2.35:1 on this card against the lightened
         variant's 3.56:1 — so if it reads dim in review, the fallback is
         vericure-logo-cobalt-text.png (#6391C9), checked in beside it, and the
         swap is one filename.

         INTERIM RASTER: an exact-alpha recolour of the original 605x77
         wordmark. Replace with a vector if one is supplied. -->
    <div class="logo-container">
      <img src="assets/vericure-logo-cobalt.png" alt="Vericure" class="vericure-logo">
    </div>
    
    <h2>{{ 'LoginSignIn' | t }}</h2>
    <div class="login-options">
      <!-- The authorization check could not reach a verdict. Deliberately NOT
     /unauthorized: nothing was established, so offering another attempt is the
     honest response — routing away would state a conclusion nobody reached. -->
<div class="auth-retry" *ngIf="authCheckFailed" role="alert">
  <p>{{ 'LoginWeCouldnTConfirmYourAccess' | t }}</p>
  <button type="button" (click)="retryAuthorization()">{{ 'LoginTryAgain' | t }}</button>
</div>
      <!-- ONE EMAIL BOX (Joel, 2026-10-07). The server says which sign-in this email's domain uses
           and that one starts, the email prefilled. No choice of identity system, on success or
           failure. A failed lookup is an error with Retry, never a list of other ways in. -->
      <form class="login-email-form" (ngSubmit)="onContinue()" *ngIf="phase !== 'google'">
        <label class="login-email-label" for="login-email">{{ 'LoginEmail' | t }}</label>
        <input
          id="login-email"
          name="email"
          type="email"
          class="login-email-input"
          autocomplete="username"
          inputmode="email"
          [(ngModel)]="email"
          [disabled]="phase === 'discovering' || phase === 'redirecting'"
          [attr.aria-invalid]="failure ? true : null"
          autofocus
        />
        <label class="login-remember">
          <input type="checkbox" name="rememberMe" [(ngModel)]="rememberMe"
            [disabled]="phase === 'discovering' || phase === 'redirecting'" />
          <span>{{ 'LoginRememberEmail' | t }}</span>
        </label>
        <button type="submit" class="login-continue"
          [disabled]="!emailValid || phase === 'discovering' || phase === 'redirecting'">
          {{ (phase === 'discovering' || phase === 'redirecting' ? 'LoginContinuing' : 'LoginContinue') | t }}
        </button>
        <button type="button" class="login-not-you" *ngIf="email && rememberMe && phase === 'enter'" (click)="notYou()">
          {{ 'LoginNotYou' | t }}
        </button>

        <div class="auth-notice login-failure" *ngIf="failure" role="alert">
          <span *ngIf="failure === 'unavailable'">{{ 'LoginDiscoverUnavailable' | t }}</span>
          <span *ngIf="failure === 'rate-limited'">{{ 'LoginDiscoverRateLimited' | t }}</span>
          <span *ngIf="failure === 'start-failed'">{{ 'LinkSomethingWentWrong' | t }}</span>
          <button type="button" class="login-retry" (click)="onContinue()" [disabled]="!emailValid">{{ 'LoginTryAgain' | t }}</button>
        </div>

        <!-- Sign-in SUCCEEDED, but this Google account is not linked to a Vericure company.
             Deliberately not /unauthorized: the person is who they say they are, and what is
             missing is onboarding, not permission. -->
        <div class="auth-notice" *ngIf="googleNotOnboarded">
          {{ 'LoginGoogleNotOnboarded' | t }}
        </div>
      </form>

      <!-- Google Workspace (reserved until Google is enabled): Google's own button, preselecting the
           email the box routed here. The only control for this address, not one of several. -->
      <div class="login-google-step" *ngIf="phase === 'google'">
        <div #googleButtonHost class="google-login-host"></div>
        <button type="button" class="login-not-you" (click)="notYou()">{{ 'LoginNotYou' | t }}</button>
      </div>
    </div>
  </div>
</div>
<!-- WAITING TO SEE IF YOU ARE ALREADY SIGNED IN — not authenticating. This state
     covers the moment before the form is revealed, while the app settles whether
     there is an existing session; nothing is being authenticated yet.
     "Authenticating…" was both inaccurate here and, in every language, nearly
     indistinguishable from the "Signing in…" the sign-in buttons show a moment
     later — so a user watching the two in sequence learned nothing from either.
     Different words for different things. -->
<div class="authprogress-center-area" *ngIf="!authStatusChceked">
  <h4>{{ 'LoginCheckingSession' | t }}</h4>
</div>
